import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { LieDigit } from '../../api/models';

export type TABLE_TYPE = Table<LieDigit>;

export const TABLE = 'lieDigit';
const SCHEMA = 'lieDigitId, headTypeId, sortId'; // headTypeId index for quick lookups

class LieDigitDatabase implements DataRepository<LieDigit> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<LieDigit | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: LieDigit, key: Key): Promise<LieDigit> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: LieDigit[]): Promise<LieDigit[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<LieDigit[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const LieDigitDB = new LieDigitDatabase(db);
